// get scripts
function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('./js/', true, /\.js$/));

// get styles
import './scss/common/style.scss';
